// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__350BU","container":"styles_container__162Jq","title":"styles_title__hecDt","wrapper":"styles_wrapper__3ksdk","answer":"styles_answer__T3LRd"};